export default "__VITE_ASSET__Cib89Cas__"